<template>
  <div class="srm-baseDetail">
    <a-row type="flex"
           align="top">
      <a-col v-for="data of columns"
             v-bind="data.layout"
             :key="data.key">
        <span class="label">
          <span v-if="data.required"
                style="color:red;">*</span>
          {{data.name}}：
        </span>
        <a-form-item class="txt"
                     style="padding:0;"
                     v-if="data.type==='formItem'">
          <a-radio-group v-if="data.inputType==='radio'"
                         v-bind="data.param"
                         @change="data.onchange"
                         v-decorator="[`${data.key}`, {
                  rules: [{required: data.required,whitespace: true,message: `请选择${data.name}`,}],
                  initialValue:Boolean(detailData[data.key])?detailData[data.key]:''}]">
            <a-radio v-for="v of data.selectData"
                     :key="v.dicKey"
                     :value="v.dicKey">{{v.dicValue}}</a-radio>
          </a-radio-group>

          <a-checkbox-group v-else-if="data.inputType==='checkbox'"
                            v-bind="data.param"
                            @change="data.onchange"
                            v-decorator="[`${data.key}`, {
                  initialValue:Boolean(detailData[data.key])?detailData[data.key].split(','):undefined}]">
            <a-checkbox v-for="v of data.selectData"
                        :key="v.dicKey"
                        :value="v.dicKey">{{v.dicValue}}</a-checkbox>
          </a-checkbox-group>

          <a-select v-else-if="data.inputType==='select'"
                    v-bind="data.param"
                    @change="data.onchange"
                    v-decorator="[`${data.key}`, {
                  rules: [{required: data.required,whitespace: true,message: `请选择${data.name}`,}],
                  initialValue:Boolean(detailData[data.key])?detailData[data.key]:''}]">
            <a-select-option v-for="v of data.selectData"
                             :key="v.dicKey"
                             :value="v.dicKey">{{v.dicValue}}</a-select-option>
          </a-select>

          <a-date-picker v-else-if="data.inputType==='date'"
                         :placeholder="data.param && data.param.disabled?'':data.name"
                         v-bind="data.param"
                         v-decorator="[`${data.key}`, {
                  rules: [{required: data.required,message: `请选择${data.name}`,}],
                  initialValue:Boolean(detailData[data.key])?moment(detailData[data.key].split(' ')[0]):moment()}]" />

          <a-textarea v-else-if="data.inputType==='textarea'"
                      :placeholder="data.param && data.param.disabled?'':data.name"
                      v-bind="data.param"
                      v-decorator="[`${data.key}`, {
                  rules: [{required: data.required,whitespace: true,message: `请输入${data.name}`,}],
                  initialValue:Boolean(detailData[data.key])?detailData[data.key]:''}]" />

          <a-input-number v-else-if="data.inputType==='inputNum'"
                          style="width:120px;"
                          :precision="data.param? data.param.precision : undefined"
                          :placeholder="data.param && data.param.disabled?'':data.name"
                          v-bind="data.param"
                          v-decorator="[`${data.key}`,{
                  rules: [{required: data.required,whitespace: true,message: `请输入${data.name}`,type:'number'}],
                  initialValue:Boolean(detailData[data.key])?Number(detailData[data.key]):''}]" />

          <a-input v-else
                   style="width:120px;"
                   :placeholder="data.param && data.param.disabled?'':data.name"
                   v-bind="data.param"
                   v-decorator="[`${data.key}`,{
                  rules: [{required: data.required,whitespace: true,message: `请输入${data.name}`,}],
                  initialValue:Boolean(detailData[data.key])?detailData[data.key]:''}]" />
        </a-form-item>
        <span class="txt"
              v-bind="data.param"
              v-else>{{detailData[data.key]}}</span>
      </a-col>
    </a-row>
  </div>
</template>
<script>
export default {
  props: {
    detailData: {
      // 详情信息
      type: Object,
      required: true,
    },
    columns: {
      // 排列规则
      type: Array,
      required: true,
    },
  },
};
</script>
<style lang="less">
.srm-baseDetail {
  padding-bottom: 12px;
  .ant-form-item-control-wrapper {
    padding: 0 !important;
    // line-height: 19px;
    margin-top: -10px;
    .ant-form-item-children > input {
      padding: 2px 11px;
      height: 28px;
    }
  }

  .ant-row-flex > div {
    padding: 6px 2px;
    font-size: 13px;
    .label {
      display: table-cell;
      min-width: 100px;
      text-align: right;
      vertical-align: top;
      float: left;
    }
    .txt {
      display: table-cell;
      // min-width: 132px;
      text-align: left;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/srm-detailMes/srm-baseDetail.vue